import { Result, Button } from 'antd'
import type { FC } from 'react'
import { i18n } from '../shared/i18n'

interface ErrorFallbackContentProps {
  error: Error | null
  onReload: () => void
  onReset: () => void
  onNavigateDashboard: () => void
}

const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  padding: '24px',
} as const

const preStyle = {
  background: '#f5f5f5',
  padding: '16px',
  borderRadius: '4px',
  fontSize: '12px',
  overflow: 'auto',
} as const

export const ErrorFallbackContent: FC<ErrorFallbackContentProps> = ({
  error,
  onReload,
  onReset,
  onNavigateDashboard,
}) => (
  <div style={containerStyle}>
    <Result
      status="500"
      title={i18n.t('pages.errorBoundary.title')}
      subTitle={i18n.t('pages.errorBoundary.subtitle')}
      extra={[
        <Button type="primary" key="reload" onClick={onReload}>
          {i18n.t('pages.errorBoundary.reloadPage')}
        </Button>,
        <Button key="dashboard" onClick={onNavigateDashboard}>
          {i18n.t('common.buttons.backToDashboard')}
        </Button>,
        <Button key="try-again" onClick={onReset}>
          {i18n.t('pages.errorBoundary.tryAgain')}
        </Button>,
      ]}
    >
      {import.meta.env.MODE === 'development' && error && (
        <div style={{ marginTop: 24, textAlign: 'left' }}>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary style={{ cursor: 'pointer', marginBottom: 8 }}>
              <strong>{i18n.t('pages.errorBoundary.errorDetails')}</strong>
            </summary>
            <pre style={preStyle}>
              {error.toString()}
              {'\n\n'}
              {error.stack}
            </pre>
          </details>
        </div>
      )}
    </Result>
  </div>
)
